export const FETCH_LOAN_DATA = 'FETCH_LOAN_DATA';
export const FETCH_SINGLE_LOAN_RECORD = 'FETCH_SINGLE_LOAN_RECORD';
export const FETCH_RECOVERY_PREVIEW_DATA = 'FETCH_RECOVERY_PREVIEW_DATA';
export const LOAN_RECOVERY_PREVIEW = 'LOAN_RECOVERY_PREVIEW';
export const BASIC_USER_LOAN_DATA = 'BASIC_USER_LOAN_DATA';
export const FETCH_FULL_RECOVERY_AMOUNT = 'FETCH_FULL_RECOVERY_AMOUNT';
